import { Button, ButtonProps } from "@/components/ui/button";
import { forwardRef } from "react";

export const GoldButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        className={`bg-gold hover:bg-gold/90 text-navy font-semibold ${className || ""}`}
        {...props}
      />
    );
  }
);
GoldButton.displayName = "GoldButton";

export const NavyButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        className={`bg-navy hover:bg-navy/90 text-white font-semibold ${className || ""}`}
        {...props}
      />
    );
  }
);
NavyButton.displayName = "NavyButton";
